<template>
  <div>
    <div class="grid pb-0" v-if="!mobiTablet">
      <div class="grid-title d-flex">
        <h4>{{ $t("BOOKING_LIST") }}</h4>
        <div class="d-flex">
          <v-btn outlined @click="exportBooking" class="ml-auto export-excel">
            <v-icon size="20" left>
              save_alt
            </v-icon>
            {{ $t("_BOOKING.EXPORT") }}
          </v-btn>
          <v-btn color="success" v-if="selectedRepost.length > 0" @click.stop="openPopupMultiReSync(selectedRepost)"
            class="ml-3">
            <i class="icon-sync fs-18 mr-2"></i> 
            {{ $t('RE_SYNC')}}
          </v-btn>
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" outlined class="ml-3">
                <i class="icon-table_chart fs-20 mr-1"></i> {{ $t('SHOW_MORE') }}
              </v-btn>
            </template>

            <v-card min-width="300">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('SHOW_MORE') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <b-form-input v-model="textSearch" :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
                </v-list-item>
                <v-list-item>
                  <p class=" mt-1 mb-0">
                    <a class="text-primary" @click="selectAllColum()">{{ $t('SELECT_ALL') }} | </a> <a class="text-primary" @click="columViews = []">{{ $t('UN_SELECT_ALL') }}</a>
                  </p>
                </v-list-item>
              </v-list>
              <v-list class="pt-0">
              
                <v-list-item style="max-height: 400px; overflow-y: auto">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group v-model="columViews"
                      :options="colums.filter(item => item.text.toString().toLowerCase().includes(textSearch.toLowerCase()))"
                      :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                  </b-form-group>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </div>
      <div class="grid-body border-top-unset list-booking-group">
        <div class="p-3">
          <div class="search-box">
            <v-btn @click="searchByCode()" outlined class="search-icon-left">
              <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
              </svg>
            </v-btn>
            <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()" type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_CODE_OTA')" />
            <v-btn outlined @click="openPopup()" class="search-icon-right">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
            </v-btn>
          </div>
          <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
          <div class="popup-search" v-if="isShowPopup">
            <!-- Coding -->
            <b-row>
              <b-col md="6" class="py-0 pr-0">
                <label>
                  {{
                    $t("_BOOKING.SEARCH_CONDITION")
                  }}
                </label>
                <v-select
                  outlined
                  dense
                  item-text="text"
                  item-value="value"
                  :items="listSearchCondition"
                  v-model="selectedSearchCondition"
                  class="w-100"
                />
              </b-col>
              <b-col v-if="selectedSearchCondition === 'BOOKING_CODE' || selectedSearchCondition === 'BOOKING_CODE_OTA'" md="6" class="py-0">
                <label>{{
                  $t("_BOOKING.SEARCH_BOOKING_CODE")
                }}</label>
                <v-text-field 
                  v-model="paging.code"
                  dense
                  outlined
                  class="w-100"
                ></v-text-field>
              </b-col>

              <b-col md="6" class="py-0"
                  v-if="
                  selectedSearchCondition === null ||
                    selectedSearchCondition === 'BOOKING_DATE' ||
                      selectedSearchCondition === 'CHECKIN_DATE' ||
                      selectedSearchCondition === 'CHECKOUT_DATE'
                  "
                >
                  <label>{{
                    $t("_BOOKING.SEARCH_DATE")
                  }}</label>
                <div>
                  <date-picker :confirm-text="$t('CONFIRM')" :clearable="false" 
                    :popup-class="'popup-calendar-desktop-detailhotel'" v-model="dateRange" :lang="languageDate" :format="selectedSearchCondition === 'BOOKING_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'" :type="selectedSearchCondition === 'BOOKING_DATE' ? 'datetime' : 'date'" :editable="false"
                    :shortcuts=[] range placeholder="Select date range">
                  </date-picker>
                </div>
              </b-col>
              <b-col md="6" class="py-0"
                v-if="selectedSearchCondition === 'STAY_DATE'">
                <label>{{
                  $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                }}</label>
                <div>
                  <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                    :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                    :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                  </date-picker>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="6" class="py-0 pr-0">
                <label>{{
                  $t("BOOKING_CHANNEL")
                }}</label>
                <v-autocomplete
                  dense
                  outlined
                  item-text="text"
                  item-value="value"
                  :items="listSelectOTA"
                  v-model="selectedOTA"
                  multiple
                  ref="selectedOTA"
                >
                <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                      @click="selectedOTA = [...new Set(selectedOTA.concat($refs['selectedOTA'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="selectedOTA = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, selectedOTA)" @click="item.select">
                      <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ selectedOTA.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
              <b-col md="6" class="py-0">
                <label>{{
                  $t("_BOOKING_TRANSACTION.BOOKING_STATUS")
                }}</label>
                <v-autocomplete
                  dense
                  outlined
                  item-text="text"
                  item-value="value"
                  :items="listBookingStatus"
                  v-model="selectedBookingStatus"
                  chips
                  multiple
                  ref="selectedBookingStatus"
                >
                  <template v-slot:prepend-item>
                    <p class="mx-3 mt-1"> <a class="text-primary"
                      @click="selectedBookingStatus = [...new Set(selectedBookingStatus.concat($refs['selectedBookingStatus'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                        class="text-primary" @click="selectedBookingStatus = []">{{ $t('UN_SELECT_ALL') }}</a>
                    </p>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                      @click:close="remove(index, selectedBookingStatus)" @click="item.select">
                      <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text caption">(+{{ selectedBookingStatus.length - 1 }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-autocomplete>
              </b-col>
            </b-row>
            <!-- End coding -->
            <!-- MORE -->
            <b-row>
              <b-col md="6" class="pr-0">
                  <label>{{
                    $t("SEARCH_BY_BOOKER")
                  }}</label>
                  <v-text-field
                    v-model="customerName"
                    dense
                    outlined
                  ></v-text-field>
              </b-col>
              <b-col md="6">
                <label>{{ $t("CUSTOMER_PHONE") }}</label>
                <v-text-field v-model="customerPhone" dense outlined></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="syncPMS" md="6" class="pt-0 pr-0">
                <label>
                  {{
                    $t("_BOOKING.SEARCH_PMS_STATUS")
                  }}
                </label>
                <v-autocomplete
                  outlined
                  dense
                  item-text="text"
                  item-value="value"
                  :items="listSearchPmsStatus"
                  v-model="selectedSearchPmsStatus"
                >
                </v-autocomplete>
              </b-col>
              <b-col :md="syncPMS ? '6' : '12'" class="pt-0">
                <label>{{ $t("_BOOKING.AGENT") }}</label>
                <v-autocomplete outlined chips dense multiple item-text="title" item-value="travelAgentCode" :items="agents"
                    v-model="bookingTravelAgent" ref="bookingTravelAgent">
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="bookingTravelAgent = [...new Set(bookingTravelAgent.concat($refs['bookingTravelAgent'].filteredItems.map(e => e.travelAgentCode)))]">
                        {{ $t('SELECT_ALL') }}</a> 
                        | <a
                          class="text-primary" @click="bookingTravelAgent = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, bookingTravelAgent)" @click="item.select">
                        <span>{{ item.title }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ [...new Set(bookingTravelAgent)].length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="pt-0 pr-0">
                <label>{{ $t("_BOOKING.MARKET") }}</label>
                <v-autocomplete outlined chips dense multiple item-text="name" item-value="code" :items="segments"
                    v-model="bookingSegments" ref="bookingSegments">
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                        @click="bookingSegments = [...new Set(bookingSegments.concat($refs['bookingSegments'].filteredItems.map(e => e.code)))]">{{ $t('SELECT_ALL') }}</a> | <a
                          class="text-primary" @click="bookingSegments = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, bookingSegments)" @click="item.select">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ bookingSegments.length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
              </b-col>
              <b-col md="6" class="pt-0">
                <label>{{ $t("UTM_CODE") }}</label>
                <v-text-field v-model="utmCode" dense outlined></v-text-field>
              </b-col>
            </b-row>
            <!-- END MORE -->
            <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
              <div class="mr-3 reset">
                <v-btn class="pl-5 pr-5" @click="reset()">
                    <v-icon size="20" left>
                      mdi-refresh
                    </v-icon>
                    {{ $t("_BOOKING.RESET") }}
                </v-btn>
              </div>
              <div class="mr-3">
                <v-btn color="primary" class="pl-5 pr-5" @click="getAll(true)">
                    <v-icon size="20" left>
                      search
                    </v-icon>
                    {{ $t("_BOOKING.SEARCH") }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- button scroll -->
        <div ref="containerCondition" class="container-condition py-4 pt-0">
          <div class="d-flex align-items-center">
            <button
              v-if="isShowArrow"
              class="left round"
              @click="scrollLeft"
            >
            <v-icon>mdi-chevron-left</v-icon>
            </button>
            
            <div ref="scrollContainer" class="overflow-auto scroll-container">
              <div v-if="conditionSearch === 'BOOKING_DATE'" class="d-inline-flex gap-3">
                <label class="" :title="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                    {{ this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE") }} {{ conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                  </div>
                </label>
              </div>

              <div  v-if="conditionSearch === 'CHECKIN_DATE'" class="d-inline-flex gap-3">
                <label class="" :title="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                    {{ this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE") }} {{ conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                  </div>
                </label>
              </div>

              <div v-if="conditionSearch === 'CHECKOUT_DATE'" class="d-inline-flex gap-3">
                <label class="" :title="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                    {{ this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE") }} {{ conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                  </div>
                </label>
              </div>

              <div v-if="conditionStayDate === 'STAY_DATE' && conditionStayDate" class="d-inline-flex gap-3">
                <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'STAY_DATE' && !isClear ? 'active-condition' : ''">
                    {{ this.$t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 'STAY_DATE' && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                  </div>
                </label>
              </div>

              <div v-if="listNameOTA && listNameOTA.length > 0" class="d-inline-flex gap-3">
                <label :title="listNameOTA.join('\n')">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameOTA.length > 0 && !isClear ? 'active-condition' : ''">
                    {{ $t("BOOKING_CHANNEL") }} {{ listNameOTA.length > 0 && !isClear ? (listNameOTA.length > 1 ? ': ' + listNameOTA[0]+'...' : ': ' + listNameOTA[0]) : ''  }}
                  </div>		
                </label>
              </div>

              <div v-if="listNameBKStatus && listNameBKStatus.length > 0" class="d-inline-flex gap-3">
                <label :title="listNameBKStatus.join('\n')">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                    {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                  </div>		
                </label>
              </div>

              <div v-if="conditionCustomerName" class="d-inline-flex gap-3">
                <label :title="conditionCustomerName">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerName && !isClear ? 'active-condition' : ''">
                    {{  $t("SEARCH_BY_BOOKER") }} {{ conditionCustomerName && !isClear ? ': ' + conditionCustomerName : '' }}
                  </div>		
                </label>
              </div>
              
              <div v-if="conditionCustomerPhone" class="d-inline-flex gap-3">
                <label :title="conditionCustomerPhone">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerPhone && !isClear ? 'active-condition' : ''">
                    {{  $t("CUSTOMER_PHONE") }} {{ conditionCustomerPhone && !isClear ? ': ' + conditionCustomerPhone : '' }}
                  </div>		
                </label>
              </div>

              <div v-if="syncPMS && listNamePmsStt && listNamePmsStt.text" class="d-inline-flex gap-3">
                <label :title="listNamePmsStt ? listNamePmsStt.text : ''">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="!isClear ? 'active-condition' : ''">
                    {{ $t("_BOOKING.SEARCH_PMS_STATUS") }} {{ !isClear ? ': ' + listNamePmsStt.text : '' }}
                  </div>		
                </label>
              </div>

              <div v-if="conditionBookingTravelAgent && conditionBookingTravelAgent.length > 0" class="d-inline-flex gap-3">
                <label :title="conditionBookingTravelAgent.join('\n')">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionBookingTravelAgent.length > 0 && !isClear ? 'active-condition' : ''">
                    {{ $t("_BOOKING.AGENT") }} {{ conditionBookingTravelAgent.length > 0 && !isClear ? (conditionBookingTravelAgent.length > 1 ? ': ' + conditionBookingTravelAgent[0]+'...' : ': ' + conditionBookingTravelAgent[0]) : ''  }}
                  </div>		
                </label>
              </div>

              <div v-if="conditionBookingSegments && conditionBookingSegments.length > 0" class="d-inline-flex gap-3">
                <label :title="conditionBookingSegments.join('\n')">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionBookingSegments.length > 0 && !isClear ? 'active-condition' : ''">
                    {{ $t("_BOOKING.MARKET") }} {{ conditionBookingSegments.length > 0 && !isClear ? (conditionBookingSegments.length > 1 ? ': ' + conditionBookingSegments[0]+'...' : ': ' + conditionBookingSegments[0]) : ''  }}
                  </div>		
                </label>
              </div>

              <div v-if="conditionUtmCode" class="d-inline-flex gap-3">
                <label :title="conditionUtmCode">
                  <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionUtmCode && !isClear ? 'active-condition' : ''">
                    {{ $t("UTM_CODE") }} {{ conditionUtmCode && !isClear ? ': ' + conditionUtmCode : '' }}
                  </div>		
                </label>
              </div>
              
            </div>
            <button
              v-if="isShowArrow"
              class="right round"
              @click="scrollRight"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </button>
          </div>
        </div>
        <!-- button scroll -->
        <v-progress-linear
          class="custom-progress"
          color="warning"
          indeterminate
          rounded
          height="3"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table v-model="selectedRepost" :headers="headers.filter(e => columViews.includes(e.value) || e.display === true)" :items="dataTable" :single-select="false" item-key="bookingCode" 
        :show-select="this.syncPMS && fnReSync ? true : false" hide-default-footer v-if="!isLoading" class="table-booking"
        :no-data-text="$t('NO_RECORDS')"
        :items-per-page="dataTable.length">  
          <!-- slot header -->
          <template v-slot:header.priceBeforeCommission="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
              </template>
              <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
            </v-tooltip>
          </template>
          <template v-slot:header.priceAfterCommission="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
              </template>
              <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.index="{ item, index }">{{ paging.offset + index + 1 }}</template>
          <template v-slot:item.bookingCustomer="{ item }">
            <a class="app-link text-decoration-none font-weight-bold"
              href="javascript:;"
              @click="goToBookingDetail(item.bookingCode)"
            >
              {{
                item.bookingCustomer.name + ' ' + item.bookingCustomer.surname
              }}
            </a>
          </template>
          <template v-slot:item.otaBookingCode="{ item }">{{ item.otaBookingCode }}</template>
          <template v-slot:item.arrival="{ item }">
            <template v-if="item.arrival && item.departure">
              {{
                _formatDateTime(
                  item.arrival,
                  "YYYY-MM-DD",
                  defaultI18n == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                ) +
                " - " +
                _formatDateTime(
                  item.departure,
                  "YYYY-MM-DD",
                  defaultI18n == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                )
              }}
            </template>
            <template v-else>N/A</template>
          </template>
          <template v-slot:item.amount="{ item }">
            <strong>{{ formatCurrency(item.amount, item.currencyCode) }}</strong>
          </template>
          <template v-slot:item.bookingStatus="{ item }">
            <span :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
              {{
                listBookingStatus.find(x => x.value == item.bookingStatus).text
              }}
            </span>
          </template>
          <template v-slot:item.bookingCode="{ item }">
            {{
              item.bookingCode
            }}
          </template>
          <template v-slot:item.bookingChannel="{ item }">
            {{item.ota.otaI18n.find(x => x.lang == defaultI18n).name}}
          </template>
          <template v-slot:item.createdDate="{ item }">
            {{utcConvertToLocalTimeZone(item.createdDate)}}
          </template>
          <template v-slot:item.agent="{ item }">
            {{ item.bookingTravelAgents.length > 0 ? item.bookingTravelAgents[0].nameVi : '' }}
          </template>
          <template v-slot:item.segment="{ item }">
            {{ item.bookingMarketSegments.length > 0 ? item.bookingMarketSegments[0].nameVi : '' }}
          </template>
          <template v-slot:item.phone="{ item }">
            {{ item.bookingCustomer.phone }}
          </template>
          <template v-slot:item.mail="{ item }">
            {{ item.bookingCustomer.email }}
          </template>
          <template v-slot:item.paymentCollectType="{ item }">
            {{ item.paymentCollectType === 0 ? 'Property collect' : item.paymentCollectType === 1 ? 'OTA contact' : 'Channel collect' }}
          </template>
          <template v-slot:item.pmsCode="{ item }">
            <template>
              <v-menu
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    :color="item.channelStatus === 1 ? 'success' : ''"
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-sm  mr-1"
                    outlined
                  >
                  <i class="icon-more_vert fs-16 cursor font-weight-bold"></i>
                  </v-btn>
                </template>

                <div class="d-flex bg-white p-2">
                  <div class="mr-3">
                    <p v-if="item.channelStatus === 1" class="m-0 pr-3">
                      <span class="text-success">{{$t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED')}}</span> <br>
                      <span class="fs-10">{{
                        utcConvertToLocalTimeZone(item.channelTime) 
                      }}</span>
                    </p>
                    <p v-else class="m-0 pr-3" >{{$t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED')}}</p>
                  </div>
                  <div class="text-right">
                    <p class="mb-0">{{ item.pmsCode.split(',').map(e => $t(e)).join(", ") }}</p>
                    <v-btn color="success" v-if="fnReSync"  x-small @click.stop="openPopupReSync(item)" ><small>{{ $t('RE_SYNC') }}</small></v-btn>
                  </div>
                </div>
              </v-menu>
            </template>
          </template>
          <template v-slot:item.commission="{ item }">
            <strong>{{ item.commission ? formatCurrency(item.commission, item.currencyCode) : 'N/A' }}</strong>
          </template>
          <template v-slot:item.priceAfterCommission="{ item }">
            <strong>{{item.priceAfterCommission ? formatCurrency(item.priceAfterCommission, item.currencyCode) : 'N/A'}}</strong>
          </template>
          <template v-slot:item.priceBeforeCommission="{ item }">
            <strong>{{item.priceBeforeCommission ? formatCurrency(item.priceBeforeCommission, item.currencyCode) : 'N/A' }}</strong>
          </template>
        </v-data-table>

       
        <v-row
          class="mt-2 mx-3"
          align="center"
          justify="center"
        >
          <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ paging.limit }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="paging.limit = number; getAll(true)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage"  class="pl-3 pr-3">
            <span slot="totalItems">{{ $t("TOTAL") }}: {{ $tc("_BOOKING.BOOKING", paging.total) }}</span>
          </paging>
        </v-row>
      </div>
    </div>
    <div class="grid pb-0" v-else>
      <div class="border-top-unset  pb-5">
        <div class="d-sticky-search d-flex align-items-center pr-0">
          <div class="mr-auto w-100">
            <v-text-field
              v-model="customerName"
              :label="$t('SEARCH_BY_BOOKER')"
              @input="searchBooking(true)"
              prepend-icon="search"
              class="mt-0 pt-0"
            ></v-text-field>
          </div>
          <div class="ml-3">
            <v-btn icon @click="openSearch(true)"><v-icon>mdi-filter</v-icon></v-btn>
            
            <div class="dot" v-if="numberFilter > 0">{{numberFilter}}</div>
          </div>
        </div>
        
        <v-progress-linear
          color="warning"
          indeterminate
          rounded
          height="3"
          v-if="isLoading"
        ></v-progress-linear>
        <div v-if="bookingList.length > 0" id="list-booking-scroll">
          <p class="title-mobile mb-0"><strong>{{ $t("TOTAL") }}: {{ $tc("_BOOKING.BOOKING", pagingMobile.total) }}</strong></p>
          <div v-for="(item, i) in bookingList" :key="i" class="d-booking-mobile" @click="goToBookingDetail(item.bookingCode)">
            <p class="mb-1 d-flex justify-content-between align-items-center">
              <strong>{{item.ota.otaI18n.find(x => x.lang == defaultI18n).name}} - {{item.bookingCustomer.name + ' ' + item.bookingCustomer.surname}}</strong>
              <span class="fs-10 color-9C9EA4">#{{ item.otaBookingCode }}</span>
            </p>
            <template v-if="defaultI18n == 'vi'">
              <div class="d-flex fs-10">
                <div>
                  <v-icon small>login</v-icon> {{  _formatDateTime(item.arrival, "YYYY-MM-DD", "DD/MM/YYYY") }}
                </div>
                <div class="ml-3">
                  <v-icon small>logout</v-icon> {{  _formatDateTime(item.departure, "YYYY-MM-DD", "DD/MM/YYYY") }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="d-flex fs-10">
                <div>
                  <v-icon small>login</v-icon> {{  _formatDateTime(item.arrival, "YYYY-MM-DD", "YYYY/MM/DD") }}
                </div>
                <div class="ml-3">
                  <v-icon small>logout</v-icon> {{  _formatDateTime(item.departure, "YYYY-MM-DD", "YYYY/MM/DD") }}
                </div>
              </div>
            </template>
            <p class="mt-2 border-bottom mb-2 pb-2 fs-10 color-9C9EA4">
              <v-icon small class="color-9C9EA4">calendar_today</v-icon>
                {{utcConvertToLocalTimeZone(item.updatedDate)}}
            </p>
            <div class="d-flex justify-content-between">
              <div :style="{ color : listBookingStatus.find( x => x.value == item.bookingStatus ).color, background: listBookingStatus.find( x => x.value == item.bookingStatus).bg}" class="d-status-booking">{{ listBookingStatus.find( x => x.value == item.bookingStatus ).text }}</div>
              <div><strong>{{ formatCurrency(item.amount, item.currencyCode) }}</strong></div>
            </div>
          </div>
        </div>
        <template v-if="!isLoading && bookingList.length === 0">
          <div class="d-flex justify-content-center align-items-center" style="height: 70vh">
            <div class="text-center">
              <img src="@/assets/not_found.png"/>
              <p class="mt-3"> {{ $t('BOOKING_EMPTY') }}</p>
            </div>
          </div>
        </template>
        <div id="overlay" @click="closeNav()"></div>
        <div id="my-search" class="sidenav-search">
          <v-toolbar
            color="white"
            flat
          >
            <v-btn
              icon
              light
              @click="closeNav()"
            >
              <v-icon color="grey darken-2">
                mdi-arrow-left
              </v-icon>
            </v-btn>

            <v-toolbar-title class="grey--text text--darken-4 fs-15" style="padding-left: 105px;">
              <strong>{{$t('FILTER_RESULTS')}}</strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-if="numberFilter > 0" @click="removeFilter">
              <v-icon color="red">filter_alt_off</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row class="bg-white m-0 fs-10">
            <v-col cols="12">
              <label>
                {{
                  $t("_BOOKING.SEARCH_CONDITION")
                }}
              </label>
              <v-select
                outlined
                dense
                item-text="text"
                item-value="value"
                :items="listSearchCondition"
                v-model="selectedSearchCondition"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <div v-if="selectedSearchCondition === 'BOOKING_CODE' || selectedSearchCondition === 'BOOKING_CODE_OTA'">
                <label>{{
                  $t("_BOOKING.SEARCH_BOOKING_CODE")
                }}</label>
                <v-text-field 
                  v-model="pagingMobile.code"
                  dense
                  outlined
                ></v-text-field>
              </div>
              <div
                v-if="
                  selectedSearchCondition === 'BOOKING_DATE' ||
                    selectedSearchCondition === 'CHECKIN_DATE' ||
                    selectedSearchCondition === 'CHECKOUT_DATE'
                "
              >
                <label>{{
                  $t("_BOOKING.SEARCH_DATE")
                }}</label>
                <div class="d-flex justify-content-between">
                  <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"  
                    :popup-class="'popup-calendar-mobile'" v-model="dateRange" :lang="languageDate" :format="selectedSearchCondition === 'BOOKING_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'"
                    :type="selectedSearchCondition === 'BOOKING_DATE' ? 'datetime' : 'date'"  :editable="false"
                    :shortcuts=[] range placeholder="Select date range">
                  </date-picker>
                </div>
              </div>
              <div
                v-if="selectedSearchCondition === 'STAY_DATE'">
                <label>{{
                  $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                }}</label>
                <div class="d-flex justify-content-between">
                  <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                    :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                    :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                  </date-picker>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="pt-0">
              <label>{{
                $t("BOOKING_CHANNEL")
              }}</label>
              <v-autocomplete item-text="text" item-value="value" :items="listSelectOTA.filter(e => e.value)" v-model="pagingMobile.otaId" outlined chips dense multiple deletable-chips>
                <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0">
              <label>{{
                $t("_BOOKING.BOOKING_STATUS")
              }}</label>
              <v-autocomplete item-text="text" item-value="value" :items="listBookingStatus.filter(e => e.value !== null)" v-model="pagingMobile.status" outlined chips dense multiple deletable-chips>
                <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-btn 
              color="primary"
              class="pl-5 pr-5 w-100"
              @click="searchBooking(true)"
            >
              <v-icon size="20" left>
                search
              </v-icon>
              {{ $t("_BOOKING.SEARCH") }}
            </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <confirm-dialog
      @deleteItem="reSync"
      :maxWidth="325"
      :persistent="true"
      ref="reSyncDialogComponent"
    >
      <span slot="title"
        >{{ $t("CONFIRM_RE_SYNC") }} booking: {{bookingReSync ? bookingReSync.otaBookingCode : null}}</span
      >
    </confirm-dialog>
    <confirm-dialog @deleteItem="reSyncs" :maxWidth="325" :persistent="true" ref="reSyncsDialogComponent">
      <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking</span>
    </confirm-dialog>
    <v-navigation-drawer
      v-model="showDetail"
      absolute
      temporary
      right
      width="1000"
    >
      <booking-detail 
      v-if="showDetail" 
      :code="code" 
      @close="()=> {showDetail = false}"
      @reload="reload"
      ></booking-detail>
    </v-navigation-drawer>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Paging from "@/components/Utils/Paging.vue";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import {
  _alert,
  _formatCurrency,
  _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import { service } from "@/_services/Booking/booking.service.js";
import moment from "moment";
import FileSaver from "file-saver";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { agentService } from "@/_services/HotelSetting/agent.service.js";
import { systemService } from "@/_services/system-data.service.js";
import BookingDetail from "./BookingDetail.vue";

export default {
  components: {
    DateRangePicker,
    paging: Paging,
    "date-picker": DatePicker,
    "confirm-dialog": ConfirmDialog,
    BookingDetail,
  },
  data() {
    return {
      menu: false,
      textSearch: '',
      columViews: [],
      locale_data: {
        format: 'YYYY-MM-DD',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        daysOfWeek: [this.$t("_DATE_RANGE.SUNDAY"), this.$t("_DATE_RANGE.MONDAY"), this.$t("_DATE_RANGE.TUESDAY"), this.$t("_DATE_RANGE.WEDNESDAY"), this.$t("_DATE_RANGE.THURSDAY"), this.$t("_DATE_RANGE.FRIDAY"), this.$t("_DATE_RANGE.SATURDAY")],
        monthNames: [this.$t("_DATE_RANGE.JAN"), this.$t("_DATE_RANGE.FEB"), this.$t("_DATE_RANGE.MAR"), this.$t("_DATE_RANGE.APR"), this.$t("_DATE_RANGE.MAY"), this.$t("_DATE_RANGE.JUN"), this.$t("_DATE_RANGE.JUL"), this.$t("_DATE_RANGE.AUG"), this.$t("_DATE_RANGE.SEP"), this.$t("_DATE_RANGE.OTC"), this.$t("_DATE_RANGE.NOV"), this.$t("_DATE_RANGE.DEC")],
        firstDay: 1
      },
      dateRange: [],
      stayDate: null,
      systemLang: this.$i18n.locale,
      isLoading: false,
      dataTable: [],
      selectedSearchCondition: 'BOOKING_DATE',
      listSearchCondition: [
        {
          value: "BOOKING_CODE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_CODE")
        },
        {
          value: "BOOKING_CODE_OTA",
          text: this.$t("BOOKING_CODE_OTA")
        },
        {
          value: "BOOKING_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE")
        },
        {
          value: "CHECKIN_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE")
        },
        {
          value: "CHECKOUT_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE")
        },
        {
          value: "STAY_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
        }
      ],
      selectedBookingStatus: [],
      listBookingStatus: [
        // {
        //   value: null,
        //   text: this.$t("ALL"),
        //   color: "primary",
        //   colorText: 'text-white'
        // },
        {
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)",
          bg: "rgba(253, 185, 19, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 1,
          text: this.$t("_BOOKING.STATUS.CONFIRM"),
          color: "#0da313",
          colorText: 'text-white'
        },
        {
          value: 2,
          text: this.$t("_BOOKING.STATUS.CANCEL"),
          color: "#808080",
          bg: "rgba(128, 128, 128, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 3,
          text: this.$t("_BOOKING.STATUS.VOID"),
          color: "#D20000",
          bg: "rgba(38, 38, 38, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 4,
          text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
          color: "#262626",
          bg: "rgba(38, 38, 38, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 5,
          text: this.$t("_BOOKING.STATUS.CLOSE"),
          color: "#262626",
          bg: "rgba(38, 38, 38, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000",
          bg: "rgba(255, 0, 0, 0.12)",
          colorText: 'text-white'
        },
        {
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f",
          bg: "rgba(254, 209, 47, 0.12)",
          colorText: 'text-white'
        },
      ],
      listSelectOTA: [],
      selectedOTA: [],
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
        searchBy: 'BOOKING_DATE',
        otaId: null
      },
      pagingMobile: {
        total: 0,
        limit: 15,
        code: null,
        offset: 0,
        searchBy: 'BOOKING_DATE',
        otaId: [],
        status: [],
      },
      customerName: null,
      customerPhone: null,
      utmCode: null,
      bookingTravelAgent: [],
      bookingList: [],
      index: 0,
      loadingView: true,
      end: true,
      syncPMS: JSON.parse(localStorage.getItem("currentUser")).hotel.syncPMS,
      fnReSync: false,
      bookingReSync: null,
      bookingReSyncs: [],
      listSearchPmsStatus: [
        {
          value: 3,
          text: this.$t("ALL")
        },
        {
          value: 1,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED")
        },
        {
          value: 0,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED")
        },
      ],
      listSearchPmsCode: [
        {
          value: null,
          text: this.$t("ALL")
        },
        {
          value: 'ez_FOLIO',
          text: this.$t("ez_FOLIO")
        },
        {
          value: 'ez_CLOUDHOTEL',
          text: this.$t("ez_CLOUDHOTEL")
        },
        {
          value: '',
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.UNSYNCHRONIZED")
        },
      ],
      selectedSearchPmsStatus: 3,
      selectedSearchPmsCode: null,
      selectedRepost: [],
      colums: [
        {
          text: this.$t("_BOOKING.AGENT"),
          value: "agent",
        },
        {
          text: this.$t("_BOOKING.MARKET"),
          value: "segment",
        },
        {
          text: this.$t("CUSTOMER_MAIL"),
          value: "mail",
        },
        {
          text: this.$t("CUSTOMER_PHONE"),
          value: "phone",
        },
        {
          text: this.$t("NUMBER_ROOM"),
          value: "totalRooms",
        },
        {
          text: this.$t("NUMBER_NIGHT"),
          value: "nights",
        },
        {
          text: "UTM Source",
          value: "utmSource",
        },
        {
          text: "UTM Medium",
          value: "utmMedium",
        },
        {
          text: "UTM Campaign",
          value: "utmCampaign",
        },
        {
          text: "UTM Term",
          value: "utmTerm",
        },
        {
          text: "UTM Content",
          value: "utmContent",
        },
        {
          text: "Payment collect",
          value: "paymentCollectType",
        },
        {
          text: this.$t('_BOOKING_DETAIL.COMMISSION'),
          value: "commission",
        },
        {
          text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
          value: "priceBeforeCommission",
        },
        {
          text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
          value: "priceAfterCommission",
        },
      ],
      agents: [],
      segments: [],
      bookingSegments: [],
      showDetail: false,
      code: null,
      currentRoute: this.$route.path,
      isShowPopup: false,
      isScrollLeftDisabled: true,
      isScrollRightDisabled: false,
      listNameOTA: [],
      listNameBKStatus: [],
      listNamePmsStt: [],
      conditionStayDate: null,
      bookingCodeSearch: '',
      conditionUtmCode: null,
      conditionCustomerName: null,
      conditionCustomerPhone: null,
      conditionBookingTravelAgent: [],
      conditionBookingSegments: [],
      isClear: false,
      conditionDateRange: [],
      conditionSearch: 'BOOKING_DATE',
      widthScroll: 0,
      widthContainer: 0,
      resizeObserver: null,
      isShowArrow: false
    };
  },
  watch: {
    showDetail() {
      if(this.showDetail == false) {
        history.pushState(null, '', `${this.currentRoute}`);
      }
    },
    selectedBookingStatus() {
      this.paging.status = this.selectedBookingStatus;
    },
    selectedSearchCondition() {
      this.paging.searchBy = this.selectedSearchCondition;
      this.pagingMobile.searchBy = this.selectedSearchCondition;
    },
    selectedOTA(){
      this.paging.otaId = this.selectedOTA;
    },
    dateRange(){
      this.paging.from = this.dateRange[0];
      this.paging.to = this.dateRange[1];
      this.pagingMobile.from = this.dateRange[0];
      this.pagingMobile.to = this.dateRange[1];
    },
    widthScroll() {
      if (this.widthScroll + 50 > this.widthContainer) {
        this.isShowArrow = true;
      } else {
        this.isShowArrow = false;
      }
    }
  },
  mounted() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles
        ? currentUser.user.roles.map(role => role.fnCode)
        : undefined;
      this.fnReSync = userRole.indexOf("HOTEL_BOOKING_REPOST") >= 0;
    let ojbBooking = sessionStorage.getItem('ojbBooking');
    if (ojbBooking) {
      ojbBooking = JSON.parse(ojbBooking);
      this.selectedSearchCondition = ojbBooking.selectedSearchCondition;
      this.dateRange = [new Date(ojbBooking.dateRange[0]), new Date(ojbBooking.dateRange[1])];
      this.stayDate = new Date(ojbBooking.stayDate);
      this.paging = ojbBooking.paging;
      this.paging.offset = 0;
      if (ojbBooking.selectedBookingStatus.length == 0) {
        this.paging.status = null;
      }
      this.selectedOTA = ojbBooking.selectedOTA;
      this.selectedBookingStatus = ojbBooking.selectedBookingStatus;
      this.customerName = ojbBooking.customerName;
      this.customerPhone = ojbBooking.customerPhone;
      this.selectedSearchPmsStatus = ojbBooking.selectedSearchPmsStatus;
      this.bookingTravelAgent = ojbBooking.bookingTravelAgent;
      this.bookingSegments = ojbBooking.bookingSegments;
      this.utmCode = ojbBooking.utmCode;
    } else {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
        this.dateRange = [today,
        day1
        ];
      this.stayDate = new Date(moment().format('YYYY-MM-DD'));
    }
    this.initialize();
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === this.$refs.scrollContainer) {
          this.widthScroll = entry.contentRect.width;
        } else if (entry.target === this.$refs.containerCondition) {
          this.widthContainer = entry.contentRect.width;
        }
      }
    });
    this.resizeObserver.observe(this.$refs.scrollContainer);
    this.resizeObserver.observe(this.$refs.containerCondition);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  computed: {
    numberSearch() {
      var num = 0
      if (this.customerName) {
        num += 1;
      }
      if (this.selectedSearchPmsStatus !== null) {
        num += 1;
      }
      if (this.utmCode) {
        num += 1;
      }
      if (this.bookingTravelAgent.length > 0) {
        num += 1;
      }
      if (this.bookingSegments.length > 0) {
        num += 1;
      }
      if (this.customerPhone) {
        num += 1;
      }
      return num
    },
    numberFilter() {
      var num = 0;
      switch (this.selectedSearchCondition) {
        case 'BOOKING_CODE':
          if (this.pagingMobile.code) {
            num += 1
          }
          break;
      
        case 'BOOKING_CODE_OTA':
            if (this.pagingMobile.code) {
              num += 1
            }
            break;
        
        case 'BOOKING_DATE':
            num += 1
            break;
        
        case 'CHECKIN_DATE':
            num += 1
            break;
        
        case 'CHECKOUT_DATE':
            num += 1
            break;
        default:
          break;
      }
      if (this.pagingMobile.status.length > 0) {
        num += 1;
      }
      if (this.pagingMobile.otaId.length > 0) {
        num += 1;
      }
      return num;
    },
    headers() {
      return [
        {
          text: this.$t("STT"),
          align: 'center',
          value: 'index',
          sortable: false,
          display: true
        },
        {
          text: this.$t("BOOKING_CUSTOMER_NAME"),
          value: "bookingCustomer",
          display: true
        },
        {
          text: this.$t("BOOKING_CODE_OTA"),
          value: "otaBookingCode",
          display: true
        },
        {
          text: this.$t("_BOOKING.TIME_STAY"),
          value: "arrival",
          class: "text-center",
          display: true
        },
        {
          text: this.$t("_BOOKING.AMOUNT"),
          value: "amount",
          align: 'end',
          display: true
        },
        {
          text: this.$t("_BOOKING.AGENT"),
          value: "agent",
        },
        {
          text: this.$t("_BOOKING.MARKET"),
          value: "segment",
        },
        {
          text: this.$t("NUMBER_ROOM"),
          value: "totalRooms",
          align: 'end',
        },
        {
          text: this.$t("NUMBER_NIGHT"),
          value: "nights",
          align: 'end',
        },
        {
          text: this.$t("_BOOKING.BOOKING_STATUS"),
          align: 'center',
          value: "bookingStatus",
          display: true
        },
        {
          text: this.$t("_BOOKING.BOOKING_CODE"),
          class: "text-center",
          value: "bookingCode",
          display: true
        },
        {
          text: this.$t("BOOKING_CHANNEL"),
          class: "text-center",
          value: "bookingChannel",
          display: true
        },
        {
          text: this.$t("_BOOKING.BOOKING_DATE"),
          value: "createdDate",
          class: "text-center",
          align: 'end',
          display: true
        },
        {
          text: this.$t("CUSTOMER_PHONE"),
          value: "phone",
        },
        {
          text: this.$t("CUSTOMER_MAIL"),
          value: "mail",
        },
        {
          text: "UTM Source",
          value: "utmSource",
        },
        {
          text: "UTM Medium",
          value: "utmMedium",
        },
        {
          text: "UTM Campaign",
          value: "utmCampaign",
        },
        {
          text: "UTM Term",
          value: "utmTerm",
        },
        {
          text: "UTM Content",
          value: "utmContent",
        },
        {
          text: "Payment collect",
          value: "paymentCollectType",
          align: 'center',
        },
        {
          text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
          value: "priceBeforeCommission",
          align: 'end',
        },
        {
          text: this.$t('_BOOKING_DETAIL.COMMISSION'),
          value: "commission",
          align: 'end',
        },
        {
          text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
          value: "priceAfterCommission",
          align: 'end',
        },
        {
          text: this.$t("_DASHBOARD.SYNC_PMS"),
          value: "pmsCode",
          align: 'center',
          class: this.syncPMS ? "text-center" : 'd-none',
          cellClass: this.syncPMS ? "text-center" : 'd-none',
          sortable: false,
          display: true
        },
      ];
    }
  },
  methods: {
    reload() {
      history.pushState(null, '', `${this.currentRoute}`);
      this.showDetail = false;
      this.initialize();
    },
    getAgents() {
      let body = {
        keyword: null,
        status: null,
        limit: 99999,
        offset: 0,
        orderBy: 'active',
        asc: false,
      };
      agentService.getAllTravelAgent(body).then(res => {
        this.agents = res.data;
      }).finally(() => (this.getSegments()));
    },
    getSegments() {
      this.segments = [];
      
      systemService.getAllSegment().then(res => {
        this.segments = res.data;
      });
    },
    selectAllColum() {
      const arr = [...this.colums.filter(item => item.text.toString().toLowerCase().includes(this.textSearch.toLowerCase())).map(e => e.value)]
      this.columViews = JSON.parse(JSON.stringify(arr))
    },
    remove(index, array) {
      array.splice(index, 1);
      this.$forceUpdate();
    },
    openPopupReSync(item) {
      this.bookingReSync = item
      this.$refs.reSyncDialogComponent.open(item)
    },
    openPopupMultiReSync(item) {
      this.bookingReSyncs = item.map(e => e.bookingCode)
      this.$refs.reSyncsDialogComponent.open(this.bookingReSyncs)
    },
    reSync(item) {
      const body = {
        bookingCode: item.bookingCode
      };
      service.reSync(body).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    reSyncs(item) {
      const body = {
        bookingCodes: [...item]
      };
      service.reSyncs(body).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    removeFilter() {
      this.selectedSearchCondition = 'BOOKING_CODE',
      this.pagingMobile.code = null;
      this.pagingMobile.status = [];
      this.pagingMobile.otaId = [];
    },
    openSearch() {
			document.getElementById('overlay').style.display = 'block';
			document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
			document.getElementById('my-search').style.top = 0;
		},
    closeNav() {
			if (document.getElementById('my-search').offsetTop === 0) {
				this.searchBooking(true);
			}
			document.getElementById('overlay').style.display = 'none';
			document.getElementById('my-search').style.top = '-130vh';
		},
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
      // return moment(value).format(outputFormat);
    },
    _formatDateTime(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return moment(value).format(outputFormat);
    },
    calcTotalAmount(bookingLines) {
      let amount = 0;
      bookingLines.forEach( x => {
        amount = amount + x.amountPax;
      });
      return _formatCurrency(amount);
    },
    formatCurrency: _formatCurrency,
    async initialize() {
      let body = {
        keyword: "",
        status: 1
      };
      await syncota.getAllOTA(body).then(res => {
        if (res.responseCode === 0) {
          res.data.forEach(x => {
            this.listSelectOTA.push({
              value: x.id,
              text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
            });
            // this.selectedOTA = this.listSelectOTA.map(e => e.value);
          });
          this.listSelectOTA.sort((a, b) => a.text.localeCompare(b.text));
          this.getAgents();
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
       if (this.mobiTablet) {
        this.searchBooking();
      } else {
        this.getAll();
      }
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Reset
    reset() {
      this.selectedSearchCondition = 'BOOKING_DATE';
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today,day1];
      this.selectedOTA = [];
      this.selectedBookingStatus = [];
      this.customerName = null;
      this.customerPhone = null;
      this.selectedSearchPmsStatus = 3;
      this.bookingTravelAgent = [];
      this.bookingSegments = [];
      this.utmCode = null;
    },
    // Get all booking
    getAll(isSearching) {
      this.isClear = false;
      this.bookingCodeSearch = '';
      this.mapValuesOTA();
      this.mapValuesBKStatus();
      this.mapValuesPmsStt();
      this.conditionStayDate = this.stayDate;
      this.conditionUtmCode = this.utmCode;
      this.conditionCustomerName = this.customerName;
      this.conditionCustomerPhone = this.customerPhone;
      this.conditionBookingTravelAgent = [...new Set(this.bookingTravelAgent)];
      this.conditionBookingSegments = [...new Set(this.bookingSegments)]
      this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
      this.conditionSearch = this.selectedSearchCondition;
      this.isShowPopup = false;
      this.paging.searchBy = this.selectedSearchCondition;
      this.isClear = false;

      if (this.paging.searchBy === null || this.paging.searchBy === 'BOOKING_DATE' || this.paging.searchBy === 'CHECKIN_DATE' || this.paging.searchBy === 'CHECKOUT_DATE') {
        if (this.isSixMonthsOrLess(this.paging.from, this.paging.to) === 1) {
          _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
          return
        }
      }
      if ((this.paging.searchBy === 'BOOKING_CODE_OTA' || this.paging.searchBy === 'BOOKING_CODE') && !this.paging.code) {
        this.paging.total = 0;
        this.dataTable = [];
        return
      }
      if (isSearching) this.paging.offset = 0;
      this.isLoading = true;
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        status: this.paging.status,
        otaIds: this.paging.otaId,
        customerName: this.customerName,
        channelStatus: this.selectedSearchPmsStatus === 3 ? null : this.selectedSearchPmsStatus,
        pmsCode: this.selectedSearchPmsCode,
        utmCode: this.utmCode,
        customerPhoneNumber: this.customerPhone,
        agentName: '',
        agentCodes:  [...this.bookingTravelAgent],
        segmentCodes: [...this.bookingSegments],
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };

      service
        .getAllBooking(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.selectedRepost = [];
            this.paging.total = res.total;
            this.dataTable = res.data;
            
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    searchByCode() {
      this.conditionDateRange = [];
      this.selectedOTA = [];
      this.selectedBookingStatus = [];
      this.customerName = null;
      this.customerPhone = null;
      this.listNamePmsStt = [];
      this.bookingTravelAgent = [];
      this.bookingSegments = [];
      this.utmCode = null;
      this.paging.searchBy = 'BOOKING_CODE_OTA';      
      if (this.paging.searchBy === 'BOOKING_CODE_OTA' && !this.bookingCodeSearch) {
        this.paging.total = 0;
        this.dataTable = [];
        return
      }
      this.isClear = true;
      this.isLoading = true;
      this.$session.set("ojbBooking", this.paging);
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: null,
        to: null,
        code: this.bookingCodeSearch,
        status: [],
        otaIds: null,
        customerName: null,
        channelStatus: null,
        pmsCode: null,
        utmCode: null,
        customerPhoneNumber: null,
        agentName: '',
        agentCodes:  [],
        segmentCodes: [],
        stayDate: null
      };
      
      service
        .getAllBooking(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.selectedRepost = [];
            this.paging.total = res.total;
            this.dataTable = res.data;
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Go to booking detail page
    goToBookingDetail(code) {
      if (this.mobiTablet) {
         this.$router.push({ name: "bookingDetailMobile", params: { code: code } });
      } else {
        this.code = code;
        let ojbBooking = {
          selectedSearchCondition: JSON.parse(JSON.stringify(this.selectedSearchCondition)),
          paging: JSON.parse(JSON.stringify(this.paging)),
          dateRange: JSON.parse(JSON.stringify(this.dateRange)),
          stayDate: JSON.parse(JSON.stringify(this.stayDate)),
          selectedOTA: JSON.parse(JSON.stringify(this.selectedOTA)),
          selectedBookingStatus: JSON.parse(JSON.stringify(this.selectedBookingStatus)),
          customerName: JSON.parse(JSON.stringify(this.customerName)),
          customerPhone: JSON.parse(JSON.stringify(this.customerPhone)),
          selectedSearchPmsStatus: JSON.parse(JSON.stringify(this.selectedSearchPmsStatus)),
          bookingTravelAgent: JSON.parse(JSON.stringify(this.bookingTravelAgent)),
          bookingSegments: JSON.parse(JSON.stringify(this.bookingSegments)),
          utmCode: JSON.parse(JSON.stringify(this.utmCode)),
        };
        sessionStorage.setItem('ojbBooking', JSON.stringify(ojbBooking));
        const routeInfo = this.$router.resolve({ 
          name: "bookingDetail",
          params: { code: code } 
        });
        history.pushState(null, '', routeInfo.href);
        this.showDetail = true;
      }
    },
    // Export booking
    exportBooking() {
      this.isLoading = true;
      let param = {
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        agentName: this.paging.agentName,
        status: this.paging.status,
        lang: this.defaultI18n,
        customerName: this.customerName,
        otaIds: this.paging.otaId,
        exportDate: moment(new Date()).format('YYYY-MM-DD_HH:mm:ss'),
        channelStatus: this.selectedSearchPmsStatus === 3 ? null : this.selectedSearchPmsStatus,
        pmsCode: this.selectedSearchPmsCode,
        utmCode: this.utmCode,
        customerPhoneNumber: this.customerPhone,
        agentName: '',
        agentCodes:  [...this.bookingTravelAgent] ,
        segmentCodes: [...this.bookingSegments],
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };
      service
        .exportBooking(param)
        .then(res => {
          if (res.responseCode === 0) {
            const url = res.data;
            FileSaver.saveAs(url);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // mobile
    viewMore() {
			this.loadingView = true;
			if (this.end === false) {
				this.index++;
			}
			this.searchBooking();
		},
    lazyLoad() {
			const list = document.getElementById('list-booking-scroll');
			if (list && list.offsetHeight &&
				window.pageYOffset >= list.offsetHeight - 800 &&
				this.loadingView === false &&
				this.end === false
			) {
				this.viewMore();
			}
		},
     searchBooking(val) {
      clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
        const body = {
          limit: 20,
          offset: this.index * 20,
          lang: this.pagingMobile.lang,
          searchBy: this.pagingMobile.searchBy,
          from: this.pagingMobile.from,
          to: this.pagingMobile.to,
          code: this.pagingMobile.code,
          status: this.pagingMobile.status,
          otaIds: this.pagingMobile.otaId,
          customerName: this.customerName,
          stayDate: moment(this.stayDate).format('YYYY-MM-DD')
        };
        if (this.index === 0 || val) {
          this.isLoading = true;
          this.index = 0;
          this.bookingList = [];
        }
        this.loadingView = true;
        this.end = true;
        this.$session.set("ojbBookingMobile", this.pagingMobile);
        service
        .getAllBookingMobile(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.pagingMobile.total = res.total;
            res.data.forEach(element => {
              this.bookingList.push(element);
            });
            this.bookingList = Array.from(new Set(this.bookingList));
            if (res.data.length < 20) {
              this.end = true;
            } else {
              this.end = false;
            }
            setTimeout(() => {
              if (this.index === 0) {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0;
                window.addEventListener('scroll', this.lazyLoad);
              }
              this.loadingView = false;
            }, 300);
          } else {
            _alert(res, this.$t(res.data), false);
          }
          document.getElementById('overlay').style.display = 'none';
			    document.getElementById('my-search').style.top = '-130vh';
          this.isLoading = false;
        })
        .finally(() => (this.loadingView = false));
			}, 500);
     
    },
    openPopup() {
      this.isShowPopup = !this.isShowPopup;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    },
    
    formatDate(condition, dateRage) {
      var dateStart = moment(dateRage[0], "YYYY-MM-DD");
      var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
      if (condition === 'BOOKING_DATE') {
        return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
      } else if (condition === 'STAY_DATE') {
        return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
      } else {
        return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
      }
    },
    mapValuesOTA() { 
      this.listNameOTA = this.selectedOTA.map(id => {
        const matchedItem = this.listSelectOTA.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesBKStatus() { 
      this.listNameBKStatus = this.selectedBookingStatus.map(id => {
        const matchedItem = this.listBookingStatus.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesPmsStt() {
      this.listNamePmsStt = this.listSearchPmsStatus.find(item => item.value === this.selectedSearchPmsStatus); 
    },
    _moment: moment
  }
};
</script>